import axios from "axios";
import type { BracketCompetitionProps, BracketCompetitionScoringRuleProps, BracketGroupProps, BracketProps, BracketRoundProps, CompanyProps, CompetitionPayoutTypeProps, CompetitionProps, CompetitionResultTypeProps, CompetitionTypeProps, CreateEngagementStepProps, GroupPlayerProps, GroupProps, LeagueProps, PollCampaignProps, PollProps, RoundEventProps, SquaresCompetitionProps } from "../../types";
import { APIOverrides } from "../../ApiOverrides";
import type { CompanyMemberProps } from "../../Authenticator/api/types";
import moment from "moment-mini";

let AUTH_SVC_API = ''
let TP_SVC_API = ''
let EVENT_SVC_API = ''
let SOCIAL_SVC_API = ''
export { CreateEngagementApi, CreateEngagementHelpers }


const CreateEngagementApi = {
    setEnvironment: () => {
        const endpoints = APIOverrides.getEndpoints();
        TP_SVC_API = endpoints['TP_SVC_API'] as string;
        EVENT_SVC_API = endpoints['EVENT_SVC_API'] as string;
        //MK_SVC_API = endpoints['MK_SVC_API'] as string;
        AUTH_SVC_API = endpoints['AUTH_SVC_API'] as string;
        SOCIAL_SVC_API = endpoints['SOCIAL_SVC_API'] as string;
    },
    getLeagues: async():Promise<LeagueProps[]> => {
        try {
            const resp = await axios.get(`${EVENT_SVC_API}/v1/leagues`);
            return resp.data.leagues
        } catch (e) {
            return []
        }
    },
    getActiveBrackets: async():Promise<BracketProps[]> => {
        try {
            const resp = await axios.get(`${EVENT_SVC_API}/v1/brackets/active`);
            return resp.data.brackets   
        } catch (e) {
            return []
        }
    },
    getBracketById: async(bracket_id:string):Promise<undefined | {bracket:BracketProps, bracket_rounds:BracketRoundProps[], round_events:RoundEventProps[], bracket_groups:BracketGroupProps[]}> => {
        try {
            const resp = await axios.get(`${EVENT_SVC_API}/v1/brackets/bracket/${bracket_id}`);
            return resp.data
        } catch (e) {
            return undefined
        }
    },
    getMyCompanies : async():Promise<{companies:CompanyProps[], company_members:CompanyMemberProps[]}> => {
        const resp = await axios.get(`${AUTH_SVC_API}/v1/companies/me`)
        const { companies, company_members } = resp.data
        return { companies, company_members }
    },
    getMyGroups: async(offset:number):Promise<{groups: GroupProps[], group_players:GroupPlayerProps[]}> => {
        try {
            const resp = await axios.get(`${SOCIAL_SVC_API}/v2/groups/me/multiple?offset=${offset}`);
            return resp.data
        } catch (e) {
            return { group_players: [], groups: [] }
        }
    },
    getTemplateCompetitions: async():Promise<CompetitionProps[]> => {
        try {
            const resp = await axios.get(`${TP_SVC_API}/v2/competitions/templates`)
            return resp.data.competitions   
        } catch (e) {
            return []
        }
    },
    createCompetition: async(competition_name:string, competition_description:string, competition_type_id:string, competition_result_type_id:string, company_id?:string, group_id?:string, pacer_id?:string, template_competition_id?:string, competition_season_id?:string, image?:any ):Promise<CompetitionProps | undefined> => {
        try {
            const resp = await axios.post(`${TP_SVC_API}/v2/competitions/competition/create`, { competition_name, competition_description, competition_type_id, competition_result_type_id, pacer_id, image, competition_season_id, group_id, company_id, template_competition_id })
            return resp.data.competition
        } catch (e) {
            return undefined
        }
    },
    getCompetitionOptions: async():Promise<{competition_types:CompetitionTypeProps[], competition_result_types:CompetitionResultTypeProps[], competition_payout_types:CompetitionPayoutTypeProps[]}> => {
        try {
            const resp = await axios.get(`${TP_SVC_API}/v1/competitions/options`)
            return resp.data
        } catch (e) {
            return { competition_payout_types: [], competition_result_types: [], competition_types: [] }
        }
    },
    createSquaresCompetition: async(squares_competition:SquaresCompetitionProps):Promise<SquaresCompetitionProps | undefined> => {
        try {
            const resp = await axios.post(`${TP_SVC_API}/v1/squares/competition/create`, { squares_competition });
            return resp.data.squares_competition
        } catch (e) {
            console.log(e)
            return undefined
        }
    },

    activateSquares: async(sq_comp_id:string) => {
        try {
            const resp = await axios.post(`${TP_SVC_API}/v1/squares/competition/activate`, { sq_comp_id });
            return resp.data.squares_competition
        } catch (e) {
            return undefined
        }
    },
    createPoll : async(poll:PollProps):Promise<PollProps | undefined> => {
       try {
            const resp = await axios.post(`${AUTH_SVC_API}/v1/polls/poll/create`, { poll })
            return resp.data.poll
       } catch (e) {
            return undefined
       }
    },
    createBracketCompetition: async(bracket_competition:BracketCompetitionProps, bracket_competition_scoring_rules:BracketCompetitionScoringRuleProps[]):Promise<undefined|{bracket_competition:BracketCompetitionProps, bracket_competition_scoring_rules:BracketCompetitionScoringRuleProps[]}> => {
        try {
            const resp = await axios.post(`${TP_SVC_API}/v1/brackets/competition/create`, { bracket_competition, bracket_competition_scoring_rules });
            return resp.data
        } catch (e) {
            return undefined
        }
    },
     createPollCampaign: async(poll_campaign:PollCampaignProps):Promise<PollCampaignProps | undefined> => {
        try {
            const resp = await axios.post(`${AUTH_SVC_API}/v1/polls/campaigns/campaign/create`, { poll_campaign })
            return resp.data.poll_campaign
        } catch (e) {
            return undefined
        }
    },
    getMyAdminFlashCampaigns: async():Promise<PollCampaignProps[]> => {
        try {
            const resp = await axios.get(`${AUTH_SVC_API}/v1/polls/admin/active`);
            return resp.data.poll_campaigns
        } catch (e) {
            return []
        }
    },
    getCompanyActiveFlashCampaigns: async(company_id:string):Promise<PollCampaignProps[]> => {
        try {
            const resp = await axios.get(`${AUTH_SVC_API}/v1/polls/company/active/${company_id}`);
            return resp.data.poll_campaigns
        } catch (e) {
            console.log(e);
            return []
        }
    }
}


const CreateEngagementHelpers = {
    isStepValid: (step:CreateEngagementStepProps, active_engagement?:string, draft_competition?:any, draft_squares?:SquaresCompetitionProps, draft_flash?:PollProps, draft_bracket?:BracketCompetitionProps):string[] => {
        let errors:string[] = []
        switch(step.step_key){
            case 'intro': return errors
            case 'options':
                if(!active_engagement){ errors.push('Please select an engagement to continue') }
                break
            case 'create':
                switch(active_engagement){
                    case 'competition':
                        if(!draft_competition){ errors.push('Draft Please complete steps'); return errors }
                        if(!draft_competition.competition_name){ errors.push('Please add a name') }
                        if(!draft_competition.competition_description){ errors.push('Please add a description') }
                        if(!draft_competition.competition_type){ errors.push('Please add a competition type') }
                        if(!draft_competition.competition_result_type){ errors.push('Please add a competition result type') }
                        break
                    case 'squares':
                        if(!draft_squares){ errors.push('Please complete steps'); return errors }
                        if(!draft_squares.sq_comp_name){ errors.push('Please add a squares name') }
                        if(!draft_squares.sq_comp_description){ errors.push('Please add a description') }
                        if(!draft_squares.event_id){ errors.push('Please add an event') }
                        break
                    case 'flash':
                        if(!draft_flash){ errors.push('Please complete the required steps') }
                        if(!draft_flash?.poll_question){ errors.push('Please add a poll question') }
                        if(!draft_flash?.poll_campaign_id){ errors.push('Please add to a compaign') }
                        break
                    case 'bracket':
                        if(!draft_bracket){ return ['Please complete the required steps'] }
                        if(!draft_bracket.scheduled_datetime){ errors.push('Please select a valid bracket') }
                        if(!draft_bracket.bracket_id){ errors.push('Please select a valid bracket') }
                        if(!draft_bracket.competition_name){ errors.push('Please enter a valid competition name') }
                        if(!draft_bracket.competition_description){ errors.push('Please enter a valid competition description') }
                        if(!draft_bracket.competition_result_type_id){ errors.push('Please add a valid payout type') }
                        if(moment().isAfter(moment(draft_bracket.scheduled_datetime))){ errors.push('The bracket selected has already started') }
                        break
                    default: break
                }
                break
            default: break
        }
        return errors
    },
    generateSquaresComp: ():SquaresCompetitionProps => {
        return {
            sq_comp_id: '',
            sq_comp_name: '',
            sq_comp_description:'',
            sq_payout_id: '1',
            sq_type_id: '1',
            invite_only_ind: true,
            event_id:'',
            sport:'',
            payout_frequency:4,
            complete_ind: false,
            begin_datetime:'',
            admin_id: '',
            minimum_square_price: 1,
            last_iteration_scored: 0,
            market_type: 'FOR_MONEY',
            potential_winnings: 0,
            create_datetime: '',last_update_datetime: ''
        }
    },
    generateEmptyFlashCampaign:():PollCampaignProps => {
        return {
            poll_campaign_id: '',
            name: '',
            market_type: 'FOR_MONEY',
            admins: [],
            player_id: '',
            company_id: '',
            status: 'active',
            phone: '0',
            total_responses: 0,
            create_datetime: '', last_update_datetime: '',
            campaign_type: 'predict',
            close_message_sent: false
        }
    },
    generateFlashMarket: ():PollProps => {
        return {
            poll_campaign_id:'',
            poll_id:'',
            poll_question: '',
            max_stake: 25,
            minimum_stake: 1,
            market_type: 'FOR_MONEY',
            status: 'pending',
            base_stake: 10,
            require_resolution: true,
            poll_type: 'select',
            show_responses: true,
            priority: 1,
            end_datetime: moment().add(1, 'day'),
            manual_close_only: false,
            stake_increase_allowed: true,
            multi_responses_allowed: true,
            create_datetime: '', last_update_datetime:''
        }
    },
    generateBracketCompetition:():BracketCompetitionProps => {
        return {
            bracket_competition_id:'',
            bracket_id: '',
            max_brackets: 100,
            max_brackets_per_player:1,
            guaranteed_payout:0,
            competition_code:'',
            competition_name:'',
            scoring_system:'progressive',
            scheduled_datetime:'',
            status:'pending',
            buy_in: 0,
            ticket_revenue:0,
            tickets_sold:0,
            competition_result_type_id: '',
            admin_id:'',
            market_type: 'FOR_MONEY',
            invite_only: true,
            create_datetime: '', last_update_datetime:'',
            image: { url : '' },
            competition_description: ''
        }
    }
}